/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=new-recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof (recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
            if(document.querySelectorAll('.new-product-card')) document.querySelectorAll('.new-product-card').forEach((grid) => {
              grid.querySelectorAll('.ng-color li').forEach((color) => {
                function activateColor(el) {
                  grid.querySelectorAll('.ng-color a').forEach((color_rm_active) => {
                    color_rm_active.classList.remove('active-color');
                  });
                  el.classList.add('active-color');
                  if (el.getAttribute('data-img') != null) {
                    grid.querySelectorAll('.product-featured-image img').forEach((img) => {
                      img.setAttribute('srcset', el.getAttribute('data-img'));
                    });
                  }
                }

                let anchor = color.querySelector('a');

                color.addEventListener('mouseover', function () {
                  activateColor(anchor);
                });

                color.addEventListener('mouseout', function () {
                  let firstAnchor = grid.querySelector('.ng-color li:first-child a');
                  if (firstAnchor && firstAnchor.getAttribute('data-img') != null) {
                    grid.querySelectorAll('.ng-color a').forEach((color_rm_active) => {
                      color_rm_active.classList.remove('active-color');
                    });
                    firstAnchor.classList.add('active-color');
                    grid.querySelectorAll('.product-featured-image img').forEach((img) => {
                      img.setAttribute('srcset', firstAnchor.getAttribute('data-img'));
                    });
                  }
                });

                color.addEventListener('click', function (e) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  activateColor(anchor);
                });
              });
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}